// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AddressesCreateData, AddressesCreateErrors, AddressesCreateResponses, AddressesDeleteData, AddressesDeleteErrors, AddressesDeleteResponses, AddressesGetData, AddressesGetErrors, AddressesGetResponses, AddressesListData, AddressesListErrors, AddressesListResponses, AddressesUpdateData, AddressesUpdateErrors, AddressesUpdateResponses, AppSettingsCreateData, AppSettingsCreateErrors, AppSettingsCreateResponses, AppSettingsDeleteData, AppSettingsDeleteErrors, AppSettingsDeleteResponses, AppSettingsGetData, AppSettingsGetErrors, AppSettingsGetResponses, AppSettingsListData, AppSettingsListErrors, AppSettingsListResponses, AppSettingsUpdateData, AppSettingsUpdateErrors, AppSettingsUpdateResponses, AttachmentsCreateData, AttachmentsCreateErrors, AttachmentsCreateResponses, AttachmentsDeleteData, AttachmentsDeleteErrors, AttachmentsDeleteResponses, AttachmentsFileData, AttachmentsFileErrors, AttachmentsFileResponses, AttachmentsFinalizeData, AttachmentsFinalizeErrors, AttachmentsFinalizeResponses, AttachmentsGetData, AttachmentsGetErrors, AttachmentsGetResponses, AttachmentsListData, AttachmentsListErrors, AttachmentsListResponses, AttachmentsRetryData, AttachmentsRetryErrors, AttachmentsRetryResponses, AttachmentsUpdateData, AttachmentsUpdateErrors, AttachmentsUpdateResponses, ChangeLogListData, ChangeLogListErrors, ChangeLogListResponses, CostCentersCreateData, CostCentersCreateErrors, CostCentersCreateResponses, CostCentersDeleteData, CostCentersDeleteErrors, CostCentersDeleteResponses, CostCentersGetData, CostCentersGetErrors, CostCentersGetResponses, CostCentersListData, CostCentersListErrors, CostCentersListResponses, CostCentersUpdateData, CostCentersUpdateErrors, CostCentersUpdateResponses, CranesCreateData, CranesCreateErrors, CranesCreateResponses, CranesDeleteData, CranesDeleteErrors, CranesDeleteResponses, CranesGetData, CranesGetErrors, CranesGetResponses, CranesListData, CranesListErrors, CranesListResponses, CranesUpdateData, CranesUpdateErrors, CranesUpdateResponses, DayBreaksCreateData, DayBreaksCreateErrors, DayBreaksCreateResponses, DayBreaksDeleteData, DayBreaksDeleteErrors, DayBreaksDeleteResponses, DayBreaksGetData, DayBreaksGetErrors, DayBreaksGetResponses, DayBreaksListData, DayBreaksListErrors, DayBreaksListResponses, DayBreaksUpdateData, DayBreaksUpdateErrors, DayBreaksUpdateResponses, EmailTemplatesDeleteData, EmailTemplatesDeleteErrors, EmailTemplatesDeleteResponses, EmailTemplatesGetData, EmailTemplatesGetErrors, EmailTemplatesGetResponses, EmailTemplatesListData, EmailTemplatesListErrors, EmailTemplatesListResponses, EmailTemplatesPreviewData, EmailTemplatesPreviewErrors, EmailTemplatesPreviewResponses, EmailTemplatesSendTestData, EmailTemplatesSendTestErrors, EmailTemplatesSendTestResponses, EmailTemplatesUpsertData, EmailTemplatesUpsertErrors, EmailTemplatesUpsertResponses, HolidaysCreateData, HolidaysCreateErrors, HolidaysCreateResponses, HolidaysDeleteData, HolidaysDeleteErrors, HolidaysDeleteResponses, HolidaysGetData, HolidaysGetErrors, HolidaysGetResponses, HolidaysListData, HolidaysListErrors, HolidaysListResponses, HolidaysUpdateData, HolidaysUpdateErrors, HolidaysUpdateResponses, HoursEntriesAdminWeekData, HoursEntriesAdminWeekErrors, HoursEntriesAdminWeekResponses, HoursEntriesBulkApproveWorkerWeekData, HoursEntriesBulkApproveWorkerWeekErrors, HoursEntriesBulkApproveWorkerWeekResponses, HoursEntriesBulkApproveWorkorderCraneWeekData, HoursEntriesBulkApproveWorkorderCraneWeekErrors, HoursEntriesBulkApproveWorkorderCraneWeekResponses, HoursEntriesCreateData, HoursEntriesCreateErrors, HoursEntriesCreateResponses, HoursEntriesGetData, HoursEntriesGetErrors, HoursEntriesGetResponses, HoursEntriesListData, HoursEntriesListErrors, HoursEntriesListResponses, HoursEntriesTransitionData, HoursEntriesTransitionErrors, HoursEntriesTransitionResponses, HoursEntriesUpdateData, HoursEntriesUpdateErrors, HoursEntriesUpdateResponses, InvitesGetData, InvitesGetErrors, InvitesGetResponses, InvitesMicrosoftStartData, InvitesMicrosoftStartErrors, InvitesMicrosoftStartResponses, InvitesSetPasswordData, InvitesSetPasswordErrors, InvitesSetPasswordResponses, LanguagesCreateData, LanguagesCreateErrors, LanguagesCreateResponses, LanguagesDeleteData, LanguagesDeleteErrors, LanguagesDeleteResponses, LanguagesGetData, LanguagesGetErrors, LanguagesGetResponses, LanguagesListData, LanguagesListErrors, LanguagesListResponses, LanguagesUpdateData, LanguagesUpdateErrors, LanguagesUpdateResponses, LodgingDeclarationsCreateData, LodgingDeclarationsCreateErrors, LodgingDeclarationsCreateResponses, LodgingDeclarationsDeleteData, LodgingDeclarationsDeleteErrors, LodgingDeclarationsDeleteResponses, LodgingDeclarationsGetData, LodgingDeclarationsGetErrors, LodgingDeclarationsGetResponses, LodgingDeclarationsInvoicePatchData, LodgingDeclarationsInvoicePatchErrors, LodgingDeclarationsInvoicePatchResponses, LodgingDeclarationsListData, LodgingDeclarationsListErrors, LodgingDeclarationsListResponses, LodgingDeclarationsParticipantAcceptData, LodgingDeclarationsParticipantAcceptErrors, LodgingDeclarationsParticipantAcceptResponses, LodgingDeclarationsParticipantRejectData, LodgingDeclarationsParticipantRejectErrors, LodgingDeclarationsParticipantRejectResponses, LodgingDeclarationsUndoData, LodgingDeclarationsUndoErrors, LodgingDeclarationsUndoResponses, LodgingDeclarationsUpdateData, LodgingDeclarationsUpdateErrors, LodgingDeclarationsUpdateResponses, MeMfaSetupData, MeMfaSetupErrors, MeMfaSetupResponses, MeMfaVerifyData, MeMfaVerifyErrors, MeMfaVerifyResponses, MeNotificationPrefsListData, MeNotificationPrefsListErrors, MeNotificationPrefsListResponses, MeNotificationPrefsUpsertData, MeNotificationPrefsUpsertErrors, MeNotificationPrefsUpsertResponses, MeWeekData, MeWeekErrors, MeWeekResponses, MeWeekSubmitData, MeWeekSubmitErrors, MeWeekSubmitResponses, TripDeclarationsCreateData, TripDeclarationsCreateErrors, TripDeclarationsCreateResponses, TripDeclarationsDeleteData, TripDeclarationsDeleteErrors, TripDeclarationsDeleteResponses, TripDeclarationsGetData, TripDeclarationsGetErrors, TripDeclarationsGetResponses, TripDeclarationsListData, TripDeclarationsListErrors, TripDeclarationsListResponses, TripDeclarationsParticipantAcceptData, TripDeclarationsParticipantAcceptErrors, TripDeclarationsParticipantAcceptResponses, TripDeclarationsParticipantRejectData, TripDeclarationsParticipantRejectErrors, TripDeclarationsParticipantRejectResponses, TripDeclarationsUndoData, TripDeclarationsUndoErrors, TripDeclarationsUndoResponses, TripDeclarationsUpdateData, TripDeclarationsUpdateErrors, TripDeclarationsUpdateResponses, UiTranslationsCreateData, UiTranslationsCreateErrors, UiTranslationsCreateResponses, UiTranslationsDeleteData, UiTranslationsDeleteErrors, UiTranslationsDeleteResponses, UiTranslationsGetData, UiTranslationsGetErrors, UiTranslationsGetResponses, UiTranslationsListData, UiTranslationsListErrors, UiTranslationsListResponses, UiTranslationsUpdateData, UiTranslationsUpdateErrors, UiTranslationsUpdateResponses, UserReplacementsCreateData, UserReplacementsCreateErrors, UserReplacementsCreateResponses, UserReplacementsDeleteData, UserReplacementsDeleteErrors, UserReplacementsDeleteResponses, UserReplacementsGetData, UserReplacementsGetErrors, UserReplacementsGetResponses, UserReplacementsListData, UserReplacementsListErrors, UserReplacementsListResponses, UserReplacementsUpdateData, UserReplacementsUpdateErrors, UserReplacementsUpdateResponses, UsersApproverResolutionData, UsersApproverResolutionErrors, UsersApproverResolutionResponses, UsersAttentionData, UsersAttentionErrors, UsersAttentionResponses, UsersBanData, UsersBanErrors, UsersBanResponses, UsersColleaguesData, UsersColleaguesErrors, UsersColleaguesResponses, UsersCreateData, UsersCreateErrors, UsersCreateResponses, UsersFacetsData, UsersFacetsErrors, UsersFacetsResponses, UsersGetData, UsersGetErrors, UsersGetResponses, UsersInviteCreateData, UsersInviteCreateErrors, UsersInviteCreateResponses, UsersInviteResendData, UsersInviteResendErrors, UsersInviteResendResponses, UsersLinkErpData, UsersLinkErpErrors, UsersLinkErpResponses, UsersListData, UsersListErrors, UsersListResponses, UsersMeData, UsersMeErrors, UsersMeResponses, UsersSetRoleData, UsersSetRoleErrors, UsersSetRoleResponses, UsersUnbanData, UsersUnbanErrors, UsersUnbanResponses, UsersUpdateData, UsersUpdateErrors, UsersUpdateResponses, WebSocketUpgradeData, WebSocketUpgradeErrors, WorkorderCranesCreateData, WorkorderCranesCreateErrors, WorkorderCranesCreateResponses, WorkorderCranesDeleteData, WorkorderCranesDeleteErrors, WorkorderCranesDeleteResponses, WorkorderCranesListData, WorkorderCranesListErrors, WorkorderCranesListResponses, WorkordersCreateData, WorkordersCreateErrors, WorkordersCreateResponses, WorkordersDeleteData, WorkordersDeleteErrors, WorkordersDeleteResponses, WorkordersGetData, WorkordersGetErrors, WorkordersGetResponses, WorkordersListData, WorkordersListErrors, WorkordersListResponses, WorkordersUpdateData, WorkordersUpdateErrors, WorkordersUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List cost centers the caller can see
 *
 * **Auth:** worker, approver, super_admin
 *
 * Returns non-deleted cost centers. Super-admin may pass ?includeDeleted=true to also receive tombstones.
 */
export const costCentersList = <ThrowOnError extends boolean = false>(options?: Options<CostCentersListData, ThrowOnError>) => (options?.client ?? client).get<CostCentersListResponses, CostCentersListErrors, ThrowOnError>({ url: '/api/v1/cost-centers', ...options });

/**
 * Create a cost center
 *
 * **Auth:** super_admin
 *
 *
 */
export const costCentersCreate = <ThrowOnError extends boolean = false>(options?: Options<CostCentersCreateData, ThrowOnError>) => (options?.client ?? client).post<CostCentersCreateResponses, CostCentersCreateErrors, ThrowOnError>({
    url: '/api/v1/cost-centers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Soft-delete a cost center (sets deleted_at)
 *
 * **Auth:** super_admin
 *
 *
 */
export const costCentersDelete = <ThrowOnError extends boolean = false>(options: Options<CostCentersDeleteData, ThrowOnError>) => (options.client ?? client).delete<CostCentersDeleteResponses, CostCentersDeleteErrors, ThrowOnError>({ url: '/api/v1/cost-centers/{id}', ...options });

/**
 * Fetch a single cost center
 *
 * **Auth:** approver, super_admin · scope: approver:cost-center (param.id)
 *
 *
 */
export const costCentersGet = <ThrowOnError extends boolean = false>(options: Options<CostCentersGetData, ThrowOnError>) => (options.client ?? client).get<CostCentersGetResponses, CostCentersGetErrors, ThrowOnError>({ url: '/api/v1/cost-centers/{id}', ...options });

/**
 * Update a cost center
 *
 * **Auth:** super_admin
 *
 *
 */
export const costCentersUpdate = <ThrowOnError extends boolean = false>(options: Options<CostCentersUpdateData, ThrowOnError>) => (options.client ?? client).patch<CostCentersUpdateResponses, CostCentersUpdateErrors, ThrowOnError>({
    url: '/api/v1/cost-centers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List workorders the caller can see
 *
 * **Auth:** worker, approver, super_admin
 *
 * Returns non-deleted workorders. Super-admin may pass ?includeDeleted=true to also receive tombstones.
 */
export const workordersList = <ThrowOnError extends boolean = false>(options?: Options<WorkordersListData, ThrowOnError>) => (options?.client ?? client).get<WorkordersListResponses, WorkordersListErrors, ThrowOnError>({ url: '/api/v1/workorders', ...options });

/**
 * Create a workorder
 *
 * **Auth:** super_admin
 *
 *
 */
export const workordersCreate = <ThrowOnError extends boolean = false>(options?: Options<WorkordersCreateData, ThrowOnError>) => (options?.client ?? client).post<WorkordersCreateResponses, WorkordersCreateErrors, ThrowOnError>({
    url: '/api/v1/workorders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Soft-delete a workorder (sets deleted_at)
 *
 * **Auth:** super_admin
 *
 *
 */
export const workordersDelete = <ThrowOnError extends boolean = false>(options: Options<WorkordersDeleteData, ThrowOnError>) => (options.client ?? client).delete<WorkordersDeleteResponses, WorkordersDeleteErrors, ThrowOnError>({ url: '/api/v1/workorders/{id}', ...options });

/**
 * Fetch a single workorder
 *
 * **Auth:** worker, approver, super_admin · scope: approver:workorder (param.id)
 *
 *
 */
export const workordersGet = <ThrowOnError extends boolean = false>(options: Options<WorkordersGetData, ThrowOnError>) => (options.client ?? client).get<WorkordersGetResponses, WorkordersGetErrors, ThrowOnError>({ url: '/api/v1/workorders/{id}', ...options });

/**
 * Update a workorder
 *
 * **Auth:** super_admin
 *
 *
 */
export const workordersUpdate = <ThrowOnError extends boolean = false>(options: Options<WorkordersUpdateData, ThrowOnError>) => (options.client ?? client).patch<WorkordersUpdateResponses, WorkordersUpdateErrors, ThrowOnError>({
    url: '/api/v1/workorders/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List holidays the caller can see
 *
 * **Auth:** worker, approver, super_admin
 *
 * Returns non-deleted holidays. Super-admin may pass ?includeDeleted=true to also receive tombstones.
 */
export const holidaysList = <ThrowOnError extends boolean = false>(options?: Options<HolidaysListData, ThrowOnError>) => (options?.client ?? client).get<HolidaysListResponses, HolidaysListErrors, ThrowOnError>({ url: '/api/v1/holidays', ...options });

/**
 * Create a holiday
 *
 * **Auth:** super_admin
 *
 *
 */
export const holidaysCreate = <ThrowOnError extends boolean = false>(options?: Options<HolidaysCreateData, ThrowOnError>) => (options?.client ?? client).post<HolidaysCreateResponses, HolidaysCreateErrors, ThrowOnError>({
    url: '/api/v1/holidays',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Soft-delete a holiday (sets deleted_at)
 *
 * **Auth:** super_admin
 *
 *
 */
export const holidaysDelete = <ThrowOnError extends boolean = false>(options: Options<HolidaysDeleteData, ThrowOnError>) => (options.client ?? client).delete<HolidaysDeleteResponses, HolidaysDeleteErrors, ThrowOnError>({ url: '/api/v1/holidays/{date}', ...options });

/**
 * Fetch a single holiday
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const holidaysGet = <ThrowOnError extends boolean = false>(options: Options<HolidaysGetData, ThrowOnError>) => (options.client ?? client).get<HolidaysGetResponses, HolidaysGetErrors, ThrowOnError>({ url: '/api/v1/holidays/{date}', ...options });

/**
 * Update a holiday
 *
 * **Auth:** super_admin
 *
 *
 */
export const holidaysUpdate = <ThrowOnError extends boolean = false>(options: Options<HolidaysUpdateData, ThrowOnError>) => (options.client ?? client).patch<HolidaysUpdateResponses, HolidaysUpdateErrors, ThrowOnError>({
    url: '/api/v1/holidays/{date}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all application settings
 *
 * **Auth:** super_admin
 *
 * Returns all application settings. This endpoint is restricted to super-admin; settings are not exposed to workers or approvers.
 */
export const appSettingsList = <ThrowOnError extends boolean = false>(options?: Options<AppSettingsListData, ThrowOnError>) => (options?.client ?? client).get<AppSettingsListResponses, AppSettingsListErrors, ThrowOnError>({ url: '/api/v1/app-settings', ...options });

/**
 * Create an application setting
 *
 * **Auth:** super_admin
 *
 *
 */
export const appSettingsCreate = <ThrowOnError extends boolean = false>(options?: Options<AppSettingsCreateData, ThrowOnError>) => (options?.client ?? client).post<AppSettingsCreateResponses, AppSettingsCreateErrors, ThrowOnError>({
    url: '/api/v1/app-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Hard-delete an application setting
 *
 * **Auth:** super_admin
 *
 *
 */
export const appSettingsDelete = <ThrowOnError extends boolean = false>(options: Options<AppSettingsDeleteData, ThrowOnError>) => (options.client ?? client).delete<AppSettingsDeleteResponses, AppSettingsDeleteErrors, ThrowOnError>({ url: '/api/v1/app-settings/{key}', ...options });

/**
 * Fetch a single application setting
 *
 * **Auth:** super_admin
 *
 *
 */
export const appSettingsGet = <ThrowOnError extends boolean = false>(options: Options<AppSettingsGetData, ThrowOnError>) => (options.client ?? client).get<AppSettingsGetResponses, AppSettingsGetErrors, ThrowOnError>({ url: '/api/v1/app-settings/{key}', ...options });

/**
 * Update an application setting
 *
 * **Auth:** super_admin
 *
 *
 */
export const appSettingsUpdate = <ThrowOnError extends boolean = false>(options: Options<AppSettingsUpdateData, ThrowOnError>) => (options.client ?? client).patch<AppSettingsUpdateResponses, AppSettingsUpdateErrors, ThrowOnError>({
    url: '/api/v1/app-settings/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all languages (admin)
 *
 * **Auth:** super_admin
 *
 * Returns every language row, including unpublished entries and the DEV language. Restricted to super-admin. The public /api/i18n endpoint (filtered to published languages) is deferred to the Translations phase.
 */
export const languagesList = <ThrowOnError extends boolean = false>(options?: Options<LanguagesListData, ThrowOnError>) => (options?.client ?? client).get<LanguagesListResponses, LanguagesListErrors, ThrowOnError>({ url: '/api/v1/languages', ...options });

/**
 * Create a language
 *
 * **Auth:** super_admin
 *
 *
 */
export const languagesCreate = <ThrowOnError extends boolean = false>(options?: Options<LanguagesCreateData, ThrowOnError>) => (options?.client ?? client).post<LanguagesCreateResponses, LanguagesCreateErrors, ThrowOnError>({
    url: '/api/v1/languages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Hard-delete a language
 *
 * **Auth:** super_admin
 *
 *
 */
export const languagesDelete = <ThrowOnError extends boolean = false>(options: Options<LanguagesDeleteData, ThrowOnError>) => (options.client ?? client).delete<LanguagesDeleteResponses, LanguagesDeleteErrors, ThrowOnError>({ url: '/api/v1/languages/{code}', ...options });

/**
 * Fetch a single language
 *
 * **Auth:** super_admin
 *
 *
 */
export const languagesGet = <ThrowOnError extends boolean = false>(options: Options<LanguagesGetData, ThrowOnError>) => (options.client ?? client).get<LanguagesGetResponses, LanguagesGetErrors, ThrowOnError>({ url: '/api/v1/languages/{code}', ...options });

/**
 * Update a language
 *
 * **Auth:** super_admin
 *
 *
 */
export const languagesUpdate = <ThrowOnError extends boolean = false>(options: Options<LanguagesUpdateData, ThrowOnError>) => (options.client ?? client).patch<LanguagesUpdateResponses, LanguagesUpdateErrors, ThrowOnError>({
    url: '/api/v1/languages/{code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List address records the caller can see
 *
 * **Auth:** worker, approver, super_admin
 *
 * Returns non-deleted address records. Super-admin may pass ?includeDeleted=true to also receive tombstones.
 */
export const addressesList = <ThrowOnError extends boolean = false>(options?: Options<AddressesListData, ThrowOnError>) => (options?.client ?? client).get<AddressesListResponses, AddressesListErrors, ThrowOnError>({ url: '/api/v1/addresses', ...options });

/**
 * Create an address
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const addressesCreate = <ThrowOnError extends boolean = false>(options?: Options<AddressesCreateData, ThrowOnError>) => (options?.client ?? client).post<AddressesCreateResponses, AddressesCreateErrors, ThrowOnError>({
    url: '/api/v1/addresses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Soft-delete an address (sets deleted_at)
 *
 * **Auth:** super_admin
 *
 *
 */
export const addressesDelete = <ThrowOnError extends boolean = false>(options: Options<AddressesDeleteData, ThrowOnError>) => (options.client ?? client).delete<AddressesDeleteResponses, AddressesDeleteErrors, ThrowOnError>({ url: '/api/v1/addresses/{id}', ...options });

/**
 * Fetch a single address
 *
 * **Auth:** approver, super_admin
 *
 *
 */
export const addressesGet = <ThrowOnError extends boolean = false>(options: Options<AddressesGetData, ThrowOnError>) => (options.client ?? client).get<AddressesGetResponses, AddressesGetErrors, ThrowOnError>({ url: '/api/v1/addresses/{id}', ...options });

/**
 * Update an address
 *
 * **Auth:** super_admin
 *
 *
 */
export const addressesUpdate = <ThrowOnError extends boolean = false>(options: Options<AddressesUpdateData, ThrowOnError>) => (options.client ?? client).patch<AddressesUpdateResponses, AddressesUpdateErrors, ThrowOnError>({
    url: '/api/v1/addresses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List day-break records for a user
 *
 * **Auth:** worker, approver, super_admin · scope: self:user (param.userId)
 *
 * Returns all day-break records for the specified user. Workers can only list their own records.
 */
export const dayBreaksList = <ThrowOnError extends boolean = false>(options: Options<DayBreaksListData, ThrowOnError>) => (options.client ?? client).get<DayBreaksListResponses, DayBreaksListErrors, ThrowOnError>({ url: '/api/v1/users/{userId}/day-breaks', ...options });

/**
 * Create a day-break record for a user
 *
 * **Auth:** worker, approver, super_admin · scope: self:user (param.userId)
 *
 *
 */
export const dayBreaksCreate = <ThrowOnError extends boolean = false>(options: Options<DayBreaksCreateData, ThrowOnError>) => (options.client ?? client).post<DayBreaksCreateResponses, DayBreaksCreateErrors, ThrowOnError>({
    url: '/api/v1/users/{userId}/day-breaks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hard-delete a day-break record
 *
 * **Auth:** worker, approver, super_admin · scope: self:user (param.userId)
 *
 *
 */
export const dayBreaksDelete = <ThrowOnError extends boolean = false>(options: Options<DayBreaksDeleteData, ThrowOnError>) => (options.client ?? client).delete<DayBreaksDeleteResponses, DayBreaksDeleteErrors, ThrowOnError>({ url: '/api/v1/users/{userId}/day-breaks/{date}', ...options });

/**
 * Fetch a single day-break record
 *
 * **Auth:** worker, approver, super_admin · scope: self:user (param.userId)
 *
 *
 */
export const dayBreaksGet = <ThrowOnError extends boolean = false>(options: Options<DayBreaksGetData, ThrowOnError>) => (options.client ?? client).get<DayBreaksGetResponses, DayBreaksGetErrors, ThrowOnError>({ url: '/api/v1/users/{userId}/day-breaks/{date}', ...options });

/**
 * Update a day-break record for a user
 *
 * **Auth:** worker, approver, super_admin · scope: self:user (param.userId)
 *
 *
 */
export const dayBreaksUpdate = <ThrowOnError extends boolean = false>(options: Options<DayBreaksUpdateData, ThrowOnError>) => (options.client ?? client).patch<DayBreaksUpdateResponses, DayBreaksUpdateErrors, ThrowOnError>({
    url: '/api/v1/users/{userId}/day-breaks/{date}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List attachment records the caller can see
 *
 * **Auth:** super_admin
 *
 * Returns non-deleted attachment records. Super-admin may pass ?includeDeleted=true to also receive tombstones.
 */
export const attachmentsList = <ThrowOnError extends boolean = false>(options?: Options<AttachmentsListData, ThrowOnError>) => (options?.client ?? client).get<AttachmentsListResponses, AttachmentsListErrors, ThrowOnError>({ url: '/api/v1/attachments', ...options });

/**
 * Begin an attachment upload (returns a presigned PUT URL)
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const attachmentsCreate = <ThrowOnError extends boolean = false>(options?: Options<AttachmentsCreateData, ThrowOnError>) => (options?.client ?? client).post<AttachmentsCreateResponses, AttachmentsCreateErrors, ThrowOnError>({
    url: '/api/v1/attachments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete an attachment (hard when unlinked + uploader; otherwise soft)
 *
 * **Auth:** worker, approver, super_admin · scope: participant:attachment (param.id)
 *
 *
 */
export const attachmentsDelete = <ThrowOnError extends boolean = false>(options: Options<AttachmentsDeleteData, ThrowOnError>) => (options.client ?? client).delete<AttachmentsDeleteResponses, AttachmentsDeleteErrors, ThrowOnError>({ url: '/api/v1/attachments/{id}', ...options });

/**
 * Fetch a single attachment
 *
 * **Auth:** worker, approver, super_admin · scope: participant:attachment (param.id)
 *
 *
 */
export const attachmentsGet = <ThrowOnError extends boolean = false>(options: Options<AttachmentsGetData, ThrowOnError>) => (options.client ?? client).get<AttachmentsGetResponses, AttachmentsGetErrors, ThrowOnError>({ url: '/api/v1/attachments/{id}', ...options });

/**
 * Update an attachment (state transition and variant URL assignment)
 *
 * **Auth:** super_admin
 *
 *
 */
export const attachmentsUpdate = <ThrowOnError extends boolean = false>(options: Options<AttachmentsUpdateData, ThrowOnError>) => (options.client ?? client).patch<AttachmentsUpdateResponses, AttachmentsUpdateErrors, ThrowOnError>({
    url: '/api/v1/attachments/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm an upload completed; enqueue image processing
 *
 * **Auth:** worker, approver, super_admin · scope: participant:attachment (param.id)
 *
 *
 */
export const attachmentsFinalize = <ThrowOnError extends boolean = false>(options: Options<AttachmentsFinalizeData, ThrowOnError>) => (options.client ?? client).post<AttachmentsFinalizeResponses, AttachmentsFinalizeErrors, ThrowOnError>({ url: '/api/v1/attachments/{id}/finalize', ...options });

/**
 * Stream the medium or original variant
 *
 * **Auth:** worker, approver, super_admin · scope: participant:attachment (param.id)
 *
 *
 */
export const attachmentsFile = <ThrowOnError extends boolean = false>(options: Options<AttachmentsFileData, ThrowOnError>) => (options.client ?? client).get<AttachmentsFileResponses, AttachmentsFileErrors, ThrowOnError>({ url: '/api/v1/attachments/{id}/file', ...options });

/**
 * Retry pipeline processing on a failed attachment
 *
 * **Auth:** worker, approver, super_admin · scope: participant:attachment (param.id)
 *
 *
 */
export const attachmentsRetry = <ThrowOnError extends boolean = false>(options: Options<AttachmentsRetryData, ThrowOnError>) => (options.client ?? client).post<AttachmentsRetryResponses, AttachmentsRetryErrors, ThrowOnError>({ url: '/api/v1/attachments/{id}/retry', ...options });

/**
 * List all translations for a language
 *
 * **Auth:** super_admin
 *
 * Returns all translation records for the specified language, including deprecated entries. Super-admin only.
 */
export const uiTranslationsList = <ThrowOnError extends boolean = false>(options: Options<UiTranslationsListData, ThrowOnError>) => (options.client ?? client).get<UiTranslationsListResponses, UiTranslationsListErrors, ThrowOnError>({ url: '/api/v1/languages/{languageCode}/translations', ...options });

/**
 * Create a translation for a language
 *
 * **Auth:** super_admin
 *
 *
 */
export const uiTranslationsCreate = <ThrowOnError extends boolean = false>(options: Options<UiTranslationsCreateData, ThrowOnError>) => (options.client ?? client).post<UiTranslationsCreateResponses, UiTranslationsCreateErrors, ThrowOnError>({
    url: '/api/v1/languages/{languageCode}/translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deprecate a translation
 *
 * **Auth:** super_admin
 *
 * Marks the translation as deprecated by setting deprecatedAt and versionDeprecated. The row is NOT removed from the database. Supply the deprecation semver in the X-Version-Deprecated request header. Returns 404 if not found or already deprecated.
 */
export const uiTranslationsDelete = <ThrowOnError extends boolean = false>(options: Options<UiTranslationsDeleteData, ThrowOnError>) => (options.client ?? client).delete<UiTranslationsDeleteResponses, UiTranslationsDeleteErrors, ThrowOnError>({ url: '/api/v1/languages/{languageCode}/translations/{key}', ...options });

/**
 * Fetch a single translation
 *
 * **Auth:** super_admin
 *
 *
 */
export const uiTranslationsGet = <ThrowOnError extends boolean = false>(options: Options<UiTranslationsGetData, ThrowOnError>) => (options.client ?? client).get<UiTranslationsGetResponses, UiTranslationsGetErrors, ThrowOnError>({ url: '/api/v1/languages/{languageCode}/translations/{key}', ...options });

/**
 * Update a translation value
 *
 * **Auth:** super_admin
 *
 * Updates value and/or versionLastUpdated. At least one field must be supplied. key, languageCode, versionAdded, deprecatedAt, and versionDeprecated are immutable via PATCH.
 */
export const uiTranslationsUpdate = <ThrowOnError extends boolean = false>(options: Options<UiTranslationsUpdateData, ThrowOnError>) => (options.client ?? client).patch<UiTranslationsUpdateResponses, UiTranslationsUpdateErrors, ThrowOnError>({
    url: '/api/v1/languages/{languageCode}/translations/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List cranes the caller can see
 *
 * **Auth:** worker, approver, super_admin
 *
 * Returns non-deleted cranes. Super-admin may pass ?includeDeleted=true to also receive tombstones.
 */
export const cranesList = <ThrowOnError extends boolean = false>(options?: Options<CranesListData, ThrowOnError>) => (options?.client ?? client).get<CranesListResponses, CranesListErrors, ThrowOnError>({ url: '/api/v1/cranes', ...options });

/**
 * Create a crane
 *
 * **Auth:** super_admin
 *
 *
 */
export const cranesCreate = <ThrowOnError extends boolean = false>(options?: Options<CranesCreateData, ThrowOnError>) => (options?.client ?? client).post<CranesCreateResponses, CranesCreateErrors, ThrowOnError>({
    url: '/api/v1/cranes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Soft-delete a crane (sets deleted_at)
 *
 * **Auth:** super_admin
 *
 *
 */
export const cranesDelete = <ThrowOnError extends boolean = false>(options: Options<CranesDeleteData, ThrowOnError>) => (options.client ?? client).delete<CranesDeleteResponses, CranesDeleteErrors, ThrowOnError>({ url: '/api/v1/cranes/{id}', ...options });

/**
 * Fetch a single crane
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const cranesGet = <ThrowOnError extends boolean = false>(options: Options<CranesGetData, ThrowOnError>) => (options.client ?? client).get<CranesGetResponses, CranesGetErrors, ThrowOnError>({ url: '/api/v1/cranes/{id}', ...options });

/**
 * Update a crane
 *
 * **Auth:** super_admin
 *
 *
 */
export const cranesUpdate = <ThrowOnError extends boolean = false>(options: Options<CranesUpdateData, ThrowOnError>) => (options.client ?? client).patch<CranesUpdateResponses, CranesUpdateErrors, ThrowOnError>({
    url: '/api/v1/cranes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List cranes assigned to a workorder
 *
 * **Auth:** worker, approver, super_admin · scope: approver:workorder (param.workorderId)
 *
 * Returns the active cranes linked to the specified workorder via the membership table. Deleted cranes are excluded.
 */
export const workorderCranesList = <ThrowOnError extends boolean = false>(options: Options<WorkorderCranesListData, ThrowOnError>) => (options.client ?? client).get<WorkorderCranesListResponses, WorkorderCranesListErrors, ThrowOnError>({ url: '/api/v1/workorders/{workorderId}/cranes', ...options });

/**
 * Assign a crane to a workorder
 *
 * **Auth:** super_admin
 *
 *
 */
export const workorderCranesCreate = <ThrowOnError extends boolean = false>(options: Options<WorkorderCranesCreateData, ThrowOnError>) => (options.client ?? client).post<WorkorderCranesCreateResponses, WorkorderCranesCreateErrors, ThrowOnError>({
    url: '/api/v1/workorders/{workorderId}/cranes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a crane from a workorder
 *
 * **Auth:** super_admin
 *
 *
 */
export const workorderCranesDelete = <ThrowOnError extends boolean = false>(options: Options<WorkorderCranesDeleteData, ThrowOnError>) => (options.client ?? client).delete<WorkorderCranesDeleteResponses, WorkorderCranesDeleteErrors, ThrowOnError>({ url: '/api/v1/workorders/{workorderId}/cranes/{craneId}', ...options });

/**
 * List users the caller can see
 *
 * **Auth:** approver, super_admin
 *
 * Approver: only workers whose default_approver_id is the caller. Super-admin: all users. Returns UserAdmin shape for super-admin, User shape otherwise.
 */
export const usersList = <ThrowOnError extends boolean = false>(options?: Options<UsersListData, ThrowOnError>) => (options?.client ?? client).get<UsersListResponses, UsersListErrors, ThrowOnError>({ url: '/api/v1/users', ...options });

/**
 * Manually create a user (no Entra link)
 *
 * **Auth:** super_admin
 *
 *
 */
export const usersCreate = <ThrowOnError extends boolean = false>(options?: Options<UsersCreateData, ThrowOnError>) => (options?.client ?? client).post<UsersCreateResponses, UsersCreateErrors, ThrowOnError>({
    url: '/api/v1/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Current session user
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const usersMe = <ThrowOnError extends boolean = false>(options?: Options<UsersMeData, ThrowOnError>) => (options?.client ?? client).get<UsersMeResponses, UsersMeErrors, ThrowOnError>({ url: '/api/v1/users/me', ...options });

/**
 * Users without an ERP link (excludes super-admins)
 *
 * **Auth:** super_admin
 *
 *
 */
export const usersAttention = <ThrowOnError extends boolean = false>(options?: Options<UsersAttentionData, ThrowOnError>) => (options?.client ?? client).get<UsersAttentionResponses, UsersAttentionErrors, ThrowOnError>({ url: '/api/v1/users/attention', ...options });

/**
 * Counts per facet over the caller-scope base set
 *
 * **Auth:** approver, super_admin
 *
 * Returns role/status/erp-link counts independent of any active filter. Approver: counts limited to workers whose default_approver_id is the caller. Super-admin: counts across all users.
 */
export const usersFacets = <ThrowOnError extends boolean = false>(options?: Options<UsersFacetsData, ThrowOnError>) => (options?.client ?? client).get<UsersFacetsResponses, UsersFacetsErrors, ThrowOnError>({ url: '/api/v1/users/facets', ...options });

/**
 * List colleagues for crew and paid-by pickers
 *
 * **Auth:** worker, approver, super_admin
 *
 * Workers/approvers: returns the caller's peer set (shared workorders, trips, lodgings, replacements, default approver). Super-admin: returns all active non-banned users minus self.
 */
export const usersColleagues = <ThrowOnError extends boolean = false>(options?: Options<UsersColleaguesData, ThrowOnError>) => (options?.client ?? client).get<UsersColleaguesResponses, UsersColleaguesErrors, ThrowOnError>({ url: '/api/v1/users/colleagues', ...options });

/**
 * Fetch a single user
 *
 * **Auth:** worker, approver, super_admin · scope: approver:user (param.id)
 *
 *
 */
export const usersGet = <ThrowOnError extends boolean = false>(options: Options<UsersGetData, ThrowOnError>) => (options.client ?? client).get<UsersGetResponses, UsersGetErrors, ThrowOnError>({ url: '/api/v1/users/{id}', ...options });

/**
 * Update name / defaultApproverId / erpEmployeeNumber
 *
 * **Auth:** super_admin
 *
 *
 */
export const usersUpdate = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateData, ThrowOnError>) => (options.client ?? client).patch<UsersUpdateResponses, UsersUpdateErrors, ThrowOnError>({
    url: '/api/v1/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a user + send an invite email
 *
 * **Auth:** super_admin
 *
 *
 */
export const usersInviteCreate = <ThrowOnError extends boolean = false>(options?: Options<UsersInviteCreateData, ThrowOnError>) => (options?.client ?? client).post<UsersInviteCreateResponses, UsersInviteCreateErrors, ThrowOnError>({
    url: '/api/v1/users/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Resend an invite (supersedes the previous one)
 *
 * **Auth:** super_admin
 *
 *
 */
export const usersInviteResend = <ThrowOnError extends boolean = false>(options: Options<UsersInviteResendData, ThrowOnError>) => (options.client ?? client).post<UsersInviteResendResponses, UsersInviteResendErrors, ThrowOnError>({
    url: '/api/v1/users/{id}/invite/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a user's role with a required override reason
 *
 * **Auth:** super_admin
 *
 *
 */
export const usersSetRole = <ThrowOnError extends boolean = false>(options: Options<UsersSetRoleData, ThrowOnError>) => (options.client ?? client).post<UsersSetRoleResponses, UsersSetRoleErrors, ThrowOnError>({
    url: '/api/v1/users/{id}/set-role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ban a user (deactivate or archive)
 *
 * **Auth:** super_admin
 *
 *
 */
export const usersBan = <ThrowOnError extends boolean = false>(options: Options<UsersBanData, ThrowOnError>) => (options.client ?? client).post<UsersBanResponses, UsersBanErrors, ThrowOnError>({
    url: '/api/v1/users/{id}/ban',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unban a user
 *
 * **Auth:** super_admin
 *
 *
 */
export const usersUnban = <ThrowOnError extends boolean = false>(options: Options<UsersUnbanData, ThrowOnError>) => (options.client ?? client).post<UsersUnbanResponses, UsersUnbanErrors, ThrowOnError>({ url: '/api/v1/users/{id}/unban', ...options });

/**
 * Link a user to an ERP employee number
 *
 * **Auth:** super_admin
 *
 *
 */
export const usersLinkErp = <ThrowOnError extends boolean = false>(options: Options<UsersLinkErpData, ThrowOnError>) => (options.client ?? client).post<UsersLinkErpResponses, UsersLinkErpErrors, ThrowOnError>({
    url: '/api/v1/users/{id}/link-erp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview which approver a submitted entry would route to
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const usersApproverResolution = <ThrowOnError extends boolean = false>(options?: Options<UsersApproverResolutionData, ThrowOnError>) => (options?.client ?? client).get<UsersApproverResolutionResponses, UsersApproverResolutionErrors, ThrowOnError>({ url: '/api/v1/users/me/approver-resolution', ...options });

/**
 * List replacement relationships
 *
 * **Auth:** super_admin
 *
 *
 */
export const userReplacementsList = <ThrowOnError extends boolean = false>(options?: Options<UserReplacementsListData, ThrowOnError>) => (options?.client ?? client).get<UserReplacementsListResponses, UserReplacementsListErrors, ThrowOnError>({ url: '/api/v1/user-replacements', ...options });

/**
 * Create a replacement relationship
 *
 * **Auth:** super_admin
 *
 *
 */
export const userReplacementsCreate = <ThrowOnError extends boolean = false>(options?: Options<UserReplacementsCreateData, ThrowOnError>) => (options?.client ?? client).post<UserReplacementsCreateResponses, UserReplacementsCreateErrors, ThrowOnError>({
    url: '/api/v1/user-replacements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Soft-delete a replacement
 *
 * **Auth:** super_admin
 *
 *
 */
export const userReplacementsDelete = <ThrowOnError extends boolean = false>(options: Options<UserReplacementsDeleteData, ThrowOnError>) => (options.client ?? client).delete<UserReplacementsDeleteResponses, UserReplacementsDeleteErrors, ThrowOnError>({ url: '/api/v1/user-replacements/{id}', ...options });

/**
 * Fetch a replacement
 *
 * **Auth:** super_admin
 *
 *
 */
export const userReplacementsGet = <ThrowOnError extends boolean = false>(options: Options<UserReplacementsGetData, ThrowOnError>) => (options.client ?? client).get<UserReplacementsGetResponses, UserReplacementsGetErrors, ThrowOnError>({ url: '/api/v1/user-replacements/{id}', ...options });

/**
 * Update a replacement
 *
 * **Auth:** super_admin
 *
 *
 */
export const userReplacementsUpdate = <ThrowOnError extends boolean = false>(options: Options<UserReplacementsUpdateData, ThrowOnError>) => (options.client ?? client).patch<UserReplacementsUpdateResponses, UserReplacementsUpdateErrors, ThrowOnError>({
    url: '/api/v1/user-replacements/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Inspect an invite token (public)
 *
 * **Auth:** public
 *
 *
 */
export const invitesGet = <ThrowOnError extends boolean = false>(options: Options<InvitesGetData, ThrowOnError>) => (options.client ?? client).get<InvitesGetResponses, InvitesGetErrors, ThrowOnError>({ url: '/api/v1/invites/{token}', ...options });

/**
 * Set a password using a valid invite token and issue a session
 *
 * **Auth:** public
 *
 *
 */
export const invitesSetPassword = <ThrowOnError extends boolean = false>(options: Options<InvitesSetPasswordData, ThrowOnError>) => (options.client ?? client).post<InvitesSetPasswordResponses, InvitesSetPasswordErrors, ThrowOnError>({
    url: '/api/v1/invites/{token}/set-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Begin Microsoft sign-in tied to an invite
 *
 * **Auth:** public
 *
 *
 */
export const invitesMicrosoftStart = <ThrowOnError extends boolean = false>(options: Options<InvitesMicrosoftStartData, ThrowOnError>) => (options.client ?? client).post<InvitesMicrosoftStartResponses, InvitesMicrosoftStartErrors, ThrowOnError>({ url: '/api/v1/invites/{token}/microsoft/start', ...options });

/**
 * Bootstrap a TOTP secret for the caller and return otpauth URL + QR SVG
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const meMfaSetup = <ThrowOnError extends boolean = false>(options?: Options<MeMfaSetupData, ThrowOnError>) => (options?.client ?? client).get<MeMfaSetupResponses, MeMfaSetupErrors, ThrowOnError>({ url: '/api/v1/me/mfa/setup', ...options });

/**
 * Verify a TOTP code and finalize MFA enrollment for the caller
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const meMfaVerify = <ThrowOnError extends boolean = false>(options?: Options<MeMfaVerifyData, ThrowOnError>) => (options?.client ?? client).post<MeMfaVerifyResponses, MeMfaVerifyErrors, ThrowOnError>({
    url: '/api/v1/me/mfa/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get the caller's week of entries, day-breaks, lodgings, trips and rolled-up status
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const meWeek = <ThrowOnError extends boolean = false>(options: Options<MeWeekData, ThrowOnError>) => (options.client ?? client).get<MeWeekResponses, MeWeekErrors, ThrowOnError>({ url: '/api/v1/me/weeks/{weekISO}', ...options });

/**
 * Submit the caller's week for approver review — writes change_log rows and notifies the approver
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const meWeekSubmit = <ThrowOnError extends boolean = false>(options: Options<MeWeekSubmitData, ThrowOnError>) => (options.client ?? client).post<MeWeekSubmitResponses, MeWeekSubmitErrors, ThrowOnError>({ url: '/api/v1/me/weeks/{weekISO}/submit', ...options });

/**
 * List my notification preferences (one row per notification template × channel)
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const meNotificationPrefsList = <ThrowOnError extends boolean = false>(options?: Options<MeNotificationPrefsListData, ThrowOnError>) => (options?.client ?? client).get<MeNotificationPrefsListResponses, MeNotificationPrefsListErrors, ThrowOnError>({ url: '/api/v1/me/notification-prefs', ...options });

/**
 * Set my preference for a notification template × channel combination
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const meNotificationPrefsUpsert = <ThrowOnError extends boolean = false>(options: Options<MeNotificationPrefsUpsertData, ThrowOnError>) => (options.client ?? client).put<MeNotificationPrefsUpsertResponses, MeNotificationPrefsUpsertErrors, ThrowOnError>({
    url: '/api/v1/me/notification-prefs/{templateKey}/{channel}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List HoursEntry records visible to the caller
 *
 * **Auth:** worker, approver, super_admin
 *
 * Workers see their own entries. Approvers see entries routed to them. Super-admins see all.
 */
export const hoursEntriesList = <ThrowOnError extends boolean = false>(options?: Options<HoursEntriesListData, ThrowOnError>) => (options?.client ?? client).get<HoursEntriesListResponses, HoursEntriesListErrors, ThrowOnError>({ url: '/api/v1/hours-entries', ...options });

/**
 * Create a HoursEntry
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const hoursEntriesCreate = <ThrowOnError extends boolean = false>(options?: Options<HoursEntriesCreateData, ThrowOnError>) => (options?.client ?? client).post<HoursEntriesCreateResponses, HoursEntriesCreateErrors, ThrowOnError>({
    url: '/api/v1/hours-entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Weekly Urenoverzicht — pre-grouped, summarised admin view
 *
 * **Auth:** approver, super_admin
 *
 * Returns one week of hours-entries grouped by worker or by workorder×crane, with per-group roll-up status, 100/125/150/200% overtime buckets, and pauzeduur split per day. Approver: filtered to rows where approver_user_id = actor.id. Super-admin: all rows.
 */
export const hoursEntriesAdminWeek = <ThrowOnError extends boolean = false>(options: Options<HoursEntriesAdminWeekData, ThrowOnError>) => (options.client ?? client).get<HoursEntriesAdminWeekResponses, HoursEntriesAdminWeekErrors, ThrowOnError>({ url: '/api/v1/hours-entries/admin-week', ...options });

/**
 * Fetch a single HoursEntry
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const hoursEntriesGet = <ThrowOnError extends boolean = false>(options: Options<HoursEntriesGetData, ThrowOnError>) => (options.client ?? client).get<HoursEntriesGetResponses, HoursEntriesGetErrors, ThrowOnError>({ url: '/api/v1/hours-entries/{id}', ...options });

/**
 * Update a HoursEntry
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const hoursEntriesUpdate = <ThrowOnError extends boolean = false>(options: Options<HoursEntriesUpdateData, ThrowOnError>) => (options.client ?? client).patch<HoursEntriesUpdateResponses, HoursEntriesUpdateErrors, ThrowOnError>({
    url: '/api/v1/hours-entries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition a HoursEntry status
 *
 * **Auth:** approver, super_admin
 *
 *
 */
export const hoursEntriesTransition = <ThrowOnError extends boolean = false>(options: Options<HoursEntriesTransitionData, ThrowOnError>) => (options.client ?? client).post<HoursEntriesTransitionResponses, HoursEntriesTransitionErrors, ThrowOnError>({
    url: '/api/v1/hours-entries/{id}:transition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve all to_check entries for a worker in a given ISO week
 *
 * **Auth:** approver, super_admin
 *
 *
 */
export const hoursEntriesBulkApproveWorkerWeek = <ThrowOnError extends boolean = false>(options?: Options<HoursEntriesBulkApproveWorkerWeekData, ThrowOnError>) => (options?.client ?? client).post<HoursEntriesBulkApproveWorkerWeekResponses, HoursEntriesBulkApproveWorkerWeekErrors, ThrowOnError>({
    url: '/api/v1/hours-entries:bulk-approve-worker-week',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Approve all to_check entries on a workorder×crane in a given ISO week
 *
 * **Auth:** approver, super_admin
 *
 *
 */
export const hoursEntriesBulkApproveWorkorderCraneWeek = <ThrowOnError extends boolean = false>(options?: Options<HoursEntriesBulkApproveWorkorderCraneWeekData, ThrowOnError>) => (options?.client ?? client).post<HoursEntriesBulkApproveWorkorderCraneWeekResponses, HoursEntriesBulkApproveWorkorderCraneWeekErrors, ThrowOnError>({
    url: '/api/v1/hours-entries:bulk-approve-workorder-crane-week',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List trip declarations visible to the caller
 *
 * **Auth:** worker, approver, super_admin
 *
 * Workers see rows they participate in or created. Approvers see rows routed to them. Super-admins see all incl. soft-deleted.
 */
export const tripDeclarationsList = <ThrowOnError extends boolean = false>(options?: Options<TripDeclarationsListData, ThrowOnError>) => (options?.client ?? client).get<TripDeclarationsListResponses, TripDeclarationsListErrors, ThrowOnError>({ url: '/api/v1/trip-declarations', ...options });

/**
 * Create a trip declaration
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const tripDeclarationsCreate = <ThrowOnError extends boolean = false>(options?: Options<TripDeclarationsCreateData, ThrowOnError>) => (options?.client ?? client).post<TripDeclarationsCreateResponses, TripDeclarationsCreateErrors, ThrowOnError>({
    url: '/api/v1/trip-declarations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Soft-delete (withdraw) a trip declaration
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const tripDeclarationsDelete = <ThrowOnError extends boolean = false>(options: Options<TripDeclarationsDeleteData, ThrowOnError>) => (options.client ?? client).delete<TripDeclarationsDeleteResponses, TripDeclarationsDeleteErrors, ThrowOnError>({ url: '/api/v1/trip-declarations/{id}', ...options });

/**
 * Fetch a single trip declaration with segments + participants
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const tripDeclarationsGet = <ThrowOnError extends boolean = false>(options: Options<TripDeclarationsGetData, ThrowOnError>) => (options.client ?? client).get<TripDeclarationsGetResponses, TripDeclarationsGetErrors, ThrowOnError>({ url: '/api/v1/trip-declarations/{id}', ...options });

/**
 * Replace a trip declaration's segments + participants atomically
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const tripDeclarationsUpdate = <ThrowOnError extends boolean = false>(options: Options<TripDeclarationsUpdateData, ThrowOnError>) => (options.client ?? client).put<TripDeclarationsUpdateResponses, TripDeclarationsUpdateErrors, ThrowOnError>({
    url: '/api/v1/trip-declarations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept your own trip-declaration participant row
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const tripDeclarationsParticipantAccept = <ThrowOnError extends boolean = false>(options: Options<TripDeclarationsParticipantAcceptData, ThrowOnError>) => (options.client ?? client).post<TripDeclarationsParticipantAcceptResponses, TripDeclarationsParticipantAcceptErrors, ThrowOnError>({ url: '/api/v1/trip-declarations/{id}/participants/{userId}/accept', ...options });

/**
 * Reject your own trip-declaration participant row
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const tripDeclarationsParticipantReject = <ThrowOnError extends boolean = false>(options: Options<TripDeclarationsParticipantRejectData, ThrowOnError>) => (options.client ?? client).post<TripDeclarationsParticipantRejectResponses, TripDeclarationsParticipantRejectErrors, ThrowOnError>({
    url: '/api/v1/trip-declarations/{id}/participants/{userId}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Undo the most recent amend within the 60s window
 *
 * **Auth:** worker, approver, super_admin · scope: trip-declarations (param.id)
 *
 *
 */
export const tripDeclarationsUndo = <ThrowOnError extends boolean = false>(options: Options<TripDeclarationsUndoData, ThrowOnError>) => (options.client ?? client).post<TripDeclarationsUndoResponses, TripDeclarationsUndoErrors, ThrowOnError>({ url: '/api/v1/trip-declarations/{id}/undo', ...options });

/**
 * List lodging declarations visible to the caller
 *
 * **Auth:** worker, approver, super_admin
 *
 * Workers see rows they participate in or created. Approvers see rows routed to them. Super-admins see all incl. soft-deleted.
 */
export const lodgingDeclarationsList = <ThrowOnError extends boolean = false>(options?: Options<LodgingDeclarationsListData, ThrowOnError>) => (options?.client ?? client).get<LodgingDeclarationsListResponses, LodgingDeclarationsListErrors, ThrowOnError>({ url: '/api/v1/lodging-declarations', ...options });

/**
 * Create a lodging declaration
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const lodgingDeclarationsCreate = <ThrowOnError extends boolean = false>(options?: Options<LodgingDeclarationsCreateData, ThrowOnError>) => (options?.client ?? client).post<LodgingDeclarationsCreateResponses, LodgingDeclarationsCreateErrors, ThrowOnError>({
    url: '/api/v1/lodging-declarations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Soft-delete (withdraw) a lodging declaration
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const lodgingDeclarationsDelete = <ThrowOnError extends boolean = false>(options: Options<LodgingDeclarationsDeleteData, ThrowOnError>) => (options.client ?? client).delete<LodgingDeclarationsDeleteResponses, LodgingDeclarationsDeleteErrors, ThrowOnError>({ url: '/api/v1/lodging-declarations/{id}', ...options });

/**
 * Fetch a single lodging declaration with participants
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const lodgingDeclarationsGet = <ThrowOnError extends boolean = false>(options: Options<LodgingDeclarationsGetData, ThrowOnError>) => (options.client ?? client).get<LodgingDeclarationsGetResponses, LodgingDeclarationsGetErrors, ThrowOnError>({ url: '/api/v1/lodging-declarations/{id}', ...options });

/**
 * Replace a lodging declaration's participants + fields atomically
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const lodgingDeclarationsUpdate = <ThrowOnError extends boolean = false>(options: Options<LodgingDeclarationsUpdateData, ThrowOnError>) => (options.client ?? client).put<LodgingDeclarationsUpdateResponses, LodgingDeclarationsUpdateErrors, ThrowOnError>({
    url: '/api/v1/lodging-declarations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept your own lodging-declaration participant row
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const lodgingDeclarationsParticipantAccept = <ThrowOnError extends boolean = false>(options: Options<LodgingDeclarationsParticipantAcceptData, ThrowOnError>) => (options.client ?? client).post<LodgingDeclarationsParticipantAcceptResponses, LodgingDeclarationsParticipantAcceptErrors, ThrowOnError>({ url: '/api/v1/lodging-declarations/{id}/participants/{userId}/accept', ...options });

/**
 * Reject your own lodging-declaration participant row
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const lodgingDeclarationsParticipantReject = <ThrowOnError extends boolean = false>(options: Options<LodgingDeclarationsParticipantRejectData, ThrowOnError>) => (options.client ?? client).post<LodgingDeclarationsParticipantRejectResponses, LodgingDeclarationsParticipantRejectErrors, ThrowOnError>({
    url: '/api/v1/lodging-declarations/{id}/participants/{userId}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach or detach the invoice attachment; re-derives invoice_status
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const lodgingDeclarationsInvoicePatch = <ThrowOnError extends boolean = false>(options: Options<LodgingDeclarationsInvoicePatchData, ThrowOnError>) => (options.client ?? client).patch<LodgingDeclarationsInvoicePatchResponses, LodgingDeclarationsInvoicePatchErrors, ThrowOnError>({
    url: '/api/v1/lodging-declarations/{id}/invoice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Undo the most recent amend within the 60s window
 *
 * **Auth:** worker, approver, super_admin · scope: lodging-declarations (param.id)
 *
 *
 */
export const lodgingDeclarationsUndo = <ThrowOnError extends boolean = false>(options: Options<LodgingDeclarationsUndoData, ThrowOnError>) => (options.client ?? client).post<LodgingDeclarationsUndoResponses, LodgingDeclarationsUndoErrors, ThrowOnError>({ url: '/api/v1/lodging-declarations/{id}/undo', ...options });

/**
 * List audit-log rows where the caller is the affected user
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const changeLogList = <ThrowOnError extends boolean = false>(options: Options<ChangeLogListData, ThrowOnError>) => (options.client ?? client).get<ChangeLogListResponses, ChangeLogListErrors, ThrowOnError>({ url: '/api/v1/change-log', ...options });

/**
 * List every email template with per-locale fill status
 *
 * **Auth:** super_admin
 *
 *
 */
export const emailTemplatesList = <ThrowOnError extends boolean = false>(options?: Options<EmailTemplatesListData, ThrowOnError>) => (options?.client ?? client).get<EmailTemplatesListResponses, EmailTemplatesListErrors, ThrowOnError>({ url: '/api/v1/admin/email-templates', ...options });

/**
 * Get detail for a single email template
 *
 * **Auth:** super_admin
 *
 *
 */
export const emailTemplatesGet = <ThrowOnError extends boolean = false>(options: Options<EmailTemplatesGetData, ThrowOnError>) => (options.client ?? client).get<EmailTemplatesGetResponses, EmailTemplatesGetErrors, ThrowOnError>({ url: '/api/v1/admin/email-templates/{key}', ...options });

/**
 * Delete a locale-specific email template override
 *
 * **Auth:** super_admin
 *
 *
 */
export const emailTemplatesDelete = <ThrowOnError extends boolean = false>(options: Options<EmailTemplatesDeleteData, ThrowOnError>) => (options.client ?? client).delete<EmailTemplatesDeleteResponses, EmailTemplatesDeleteErrors, ThrowOnError>({ url: '/api/v1/admin/email-templates/{key}/{locale}', ...options });

/**
 * Create or update a locale-specific email template override
 *
 * **Auth:** super_admin
 *
 *
 */
export const emailTemplatesUpsert = <ThrowOnError extends boolean = false>(options: Options<EmailTemplatesUpsertData, ThrowOnError>) => (options.client ?? client).put<EmailTemplatesUpsertResponses, EmailTemplatesUpsertErrors, ThrowOnError>({
    url: '/api/v1/admin/email-templates/{key}/{locale}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render a draft email template and return the HTML/text preview
 *
 * **Auth:** super_admin
 *
 *
 */
export const emailTemplatesPreview = <ThrowOnError extends boolean = false>(options: Options<EmailTemplatesPreviewData, ThrowOnError>) => (options.client ?? client).post<EmailTemplatesPreviewResponses, EmailTemplatesPreviewErrors, ThrowOnError>({
    url: '/api/v1/admin/email-templates/{key}/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render and send a draft email template to the calling admin
 *
 * **Auth:** super_admin
 *
 *
 */
export const emailTemplatesSendTest = <ThrowOnError extends boolean = false>(options: Options<EmailTemplatesSendTestData, ThrowOnError>) => (options.client ?? client).post<EmailTemplatesSendTestResponses, EmailTemplatesSendTestErrors, ThrowOnError>({
    url: '/api/v1/admin/email-templates/{key}/send-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open the per-user realtime WebSocket
 *
 * **Auth:** worker, approver, super_admin
 *
 *
 */
export const webSocketUpgrade = <ThrowOnError extends boolean = false>(options?: Options<WebSocketUpgradeData, ThrowOnError>) => (options?.client ?? client).get<unknown, WebSocketUpgradeErrors, ThrowOnError>({ url: '/api/v1/ws', ...options });
